import styled from 'styled-components';

export const MessageRow = styled.div`
  font-size: 15px;
  color: #444444;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const Body = styled.div``;

export const Edit = styled.a`
  line-height: 23px;
`;
